import { render } from "./SaveChangesConfirmationDialog.vue?vue&type=template&id=03c88934&scoped=true"
import script from "./SaveChangesConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./SaveChangesConfirmationDialog.vue?vue&type=script&lang=js"

import "./SaveChangesConfirmationDialog.vue?vue&type=style&index=0&id=03c88934&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c88934"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QCard});qInstall(script, 'directives', {ClosePopup});
